import React from "react";
import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";
import { useJoinMotion } from "./JoinMotion";

const EDGE_RAIL = {
  content: '""',
  position: "absolute",
  insetBlock: 0,
  width: { xs: 4, md: 6 },
  background: "linear-gradient(180deg, #047857 0%, #065f46 100%)",
};

/** Editorial positioning statement shown above the citizen feature carousel. */
export default function CitizenFirstStatement() {
  const { fadeUp } = useJoinMotion();

  return (
    <Box
      component={motion.div}
      {...fadeUp}
      sx={{
        position: "relative",
        overflow: "hidden",
        width: "100%",
        mb: { xs: 3, md: 4 },
        borderRadius: "var(--radius-card)",
        border: "1px solid var(--join-border-muted)",
        bgcolor: "var(--join-surface-elevated)",
        boxShadow: "var(--join-shadow-elevated)",
        backgroundImage:
          "radial-gradient(720px circle at 50% -30%, rgba(4, 120, 87, 0.09), transparent 65%)",
        textAlign: "center",
        px: { xs: 3, md: 6 },
        py: { xs: 3.5, md: 5 },
        "&::before": { ...EDGE_RAIL, insetInlineStart: 0 },
        "&::after": { ...EDGE_RAIL, insetInlineEnd: 0 },
      }}
    >
      <Typography
        component="p"
        sx={{
          fontSize: { xs: 22, md: 34 },
          fontWeight: 800,
          letterSpacing: "-0.02em",
          lineHeight: 1.25,
          color: "var(--black-color)",
          maxWidth: 900,
          mx: "auto",
        }}
      >
        <Box
          component="span"
          sx={{ display: "block", color: "var(--dna-color-palette-black-400)", fontWeight: 700 }}
        >
          Most outreach tools begin with the organizer.
        </Box>
        <Box component="span" sx={{ display: "block" }}>
          CivixThread begins with{" "}
          <Box component="span" sx={{ color: "var(--primary-color-hover)" }}>
            the citizen
          </Box>
          .
        </Box>
      </Typography>

      <Typography
        component="p"
        sx={{
          mt: { xs: 1.75, md: 2.25 },
          fontSize: { xs: 15, md: 17 },
          lineHeight: 1.65,
          color: "var(--dna-color-palette-black-400)",
          maxWidth: 760,
          mx: "auto",
        }}
      >
        When citizens get lasting value, organizers build relationships that don&apos;t fade after
        the campaign.
      </Typography>
    </Box>
  );
}
